import { Country } from "../common/geo/country";

export interface Employment {
  status: EmploymentStatus;
  details?: EmploymentDetails; // required for selfEmployed & employed
}

export const employmentStatuses = [
  "unemployed",
  "employed",
  "selfEmployed",
  "retired",
  "student",
  "atHomeTrader",
  "homeMaker",
] as const;
export type EmploymentStatus = typeof employmentStatuses[number];

export interface EmploymentDetails {
  employer: string; // max 128 chars
  occupation: string; // BUSINESS_OCCUPATION list of accepted subtypes
  employerBusiness: string; // BUSINESS_OCCUPATION list of accepted subtypes
  employerCountry: Country;
  employerCountryAbroadExplanation?: string; //required if employerCountry is different from applicant's country of residence.
}
